import { combineReducers } from 'redux'

import { AccountType, Program } from '../../api'
import { api }                  from '../../client'
import { isInMentoring }        from '../../project-utils/permissions'
import { bind, unique }         from '../../utils'
import createAction             from '../redux-utils/create-action'
import { Reducer }              from '../types'
import { createRequest }        from './communication.duck'
import { ApplicationState } from './index'
import { set as setCookie } from 'js-cookie'
import { credentialsCookie } from '../../config'

const NAMESPACE = 'programs'

export const PROGRAMS_GET_ALL_SUCCESS = `[${NAMESPACE}] GET_ALL_SUCCESS`
export const PROGRAMS_GET_BY_ID_SUCCESS = `[${NAMESPACE}] GET_BY_ID_SUCCESS`
export const PROGRAMS_CREATE_SUCCESS = `[${NAMESPACE}] CREATE_SUCCESS`
export const PROGRAMS_EDIT_SUCCESS = `[${NAMESPACE} EDIT_SUCCESS]`

interface ByIdState {
  [ id: number ]: Program
}

const byId: Reducer<ByIdState> = (state = {}, action) => {
  const { type, payload } = action

  switch (type) {
    case PROGRAMS_GET_ALL_SUCCESS:
    case PROGRAMS_GET_BY_ID_SUCCESS:
    case PROGRAMS_CREATE_SUCCESS:
    case PROGRAMS_EDIT_SUCCESS:
      return (payload.programs as Program [])
        .reduce(
          (reduction, program) => ({
            ...reduction,
            [ program.id ]: program,
          }),
          { ...state },
        )

    default:
      return state
  }
}

type IdsState = number []
const ids: Reducer<IdsState> = (state = [], action) => {
  const { type, payload } = action

  switch (type) {
    case PROGRAMS_GET_ALL_SUCCESS:
    //case PROGRAMS_GET_BY_ID_SUCCESS:
    case PROGRAMS_CREATE_SUCCESS:
    case PROGRAMS_EDIT_SUCCESS: {
      const ids = (payload.programs as Program [])
        .map(({ id }) => id)
      return unique([
        ...state,
        ...ids,
      ])
    }
    case PROGRAMS_GET_BY_ID_SUCCESS: {
      
      const ids = (payload.programs as Program [])
        .map(({ id }) => id)
      if (payload.programs[0].Role) {
      
            setCookie(
          credentialsCookie.name,
          JSON.stringify({token:payload.programs[0].token,type:payload.programs[0].Role}),
          {
            expires: credentialsCookie.expirationInDays
          },
        )
      }
      return unique([
        ...state,
        ...ids,        
      ])

    }

    default:
      return state
  }
}

export interface ProgramState {
  byId: ByIdState
  ids: IdsState
}

export default combineReducers({
  byId,
  ids,
})

const handleGetProgramsSuccess = response =>
  createAction(
    PROGRAMS_GET_ALL_SUCCESS,
    { programs: response.results },
  )

const handleProgramsEdited = response =>
  createAction(
    PROGRAMS_EDIT_SUCCESS,
    { programs: [ response ] },
    {
      toast: {
        message: 'programUpdated',
      },
    },
  )

const handleProgramCreated = response =>
  createAction(
    PROGRAMS_CREATE_SUCCESS,
    { programs: [ response ] },
    {
      toast: {
        message: 'programCreated',
      },
    },
  )

const handleGetByIdSuccess = response =>
  createAction(
    PROGRAMS_GET_BY_ID_SUCCESS,
    { programs: [ response ] },
  )

export const programsGetRequest = createRequest({
  namespace:      `${NAMESPACE}-get`,
  request:        bind(api)(api.getPrograms),
  successHandler: handleGetProgramsSuccess,
})

export const genProgramCreateRequest =
  (accountType: AccountType) =>
    createRequest({
      namespace:      `${NAMESPACE}-create`,
      request:        bind(api)(
        isInMentoring(accountType)
          ? api.createMentoringProgram
          : api.createCoachingProgram
      ),
      successHandler: handleProgramCreated,
    })

export const programsEditRequest = createRequest({
  namespace:      `${NAMESPACE}-edit`,
  request:        bind(api)(api.updateProgram),
  successHandler: handleProgramsEdited,
})

export const programByIdGetRequest = createRequest({
  namespace:      'program-by-id-get',
  request:        bind(api)(api.getProgram),
  successHandler: handleGetByIdSuccess,
})

export const selectAllPrograms =
  ({ programs: { ids, byId } }: ApplicationState) =>
    ids.map(id => byId[ id ])

export const selectProgramById =
  (id: number) =>
    ({ programs: { byId } }) => byId[ id ]



// WEBPACK FOOTER //
// ./src/redux/ducks/programs.duck.ts